import { useState } from "react";
import { Info, X } from "lucide-react";

export function BusinessInfoWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed right-0 top-1/2 -translate-y-1/2 z-40 bg-[#131312] text-[#F6F2EB] p-3 rounded-l-xl shadow-[-4px_0_15px_rgba(0,0,0,0.1)] hover:bg-[#131312]/90 transition-colors flex flex-col items-center gap-2 group border border-r-0 border-[#131312]/10"
        aria-label="Business Information"
      >
        <Info className="size-5" />
        <span 
          className="text-[10px] font-bold tracking-widest uppercase rotate-180" 
          style={{ writingMode: 'vertical-rl' }}
        >
          Info
        </span>
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
          <div 
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setIsOpen(false)}
          />
          <div className="relative w-full max-w-2xl bg-white rounded-3xl overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-200">
            <div className="flex items-center justify-between p-6 border-b border-[#131312]/10 bg-[#F6F2EB]">
              <h2 className="text-2xl font-bold text-[#131312]">Business Information</h2>
              <button 
                onClick={() => setIsOpen(false)}
                className="p-2 hover:bg-black/5 rounded-full transition-colors text-[#131312]"
              >
                <X className="size-5" />
              </button>
            </div>
            
            <div className="p-6 sm:p-8 max-h-[80vh] overflow-y-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm text-[#131312]/80 mb-8">
                <div>
                  <p className="font-semibold text-[#131312] mb-1">Commercial Brand</p>
                  <p>Colour Club Printers</p>
                </div>
                <div>
                  <p className="font-semibold text-[#131312] mb-1">Legal Entity & Supplier</p>
                  <p>Paper Printing Services</p>
                </div>
                <div>
                  <p className="font-semibold text-[#131312] mb-1">FSC Certificate Holder</p>
                  <p>Paper Printing Services</p>
                </div>
                <div>
                  <p className="font-semibold text-[#131312] mb-1">Invoice and Bank Beneficiary</p>
                  <p>Paper Printing Services</p>
                </div>
                <div>
                  <p className="font-semibold text-[#131312] mb-1">Sales Enquiries</p>
                  <p><a href="mailto:info@colourclubprinters.com" className="hover:underline text-[#131312]">info@colourclubprinters.com</a></p>
                </div>
                <div>
                  <p className="font-semibold text-[#131312] mb-1">Legal & Compliance</p>
                  <p><a href="mailto:info@paperprintingservices.com" className="hover:underline text-[#131312]">info@paperprintingservices.com</a></p>
                </div>
              </div>
              
              <div className="pt-6 border-t border-[#131312]/10">
                <p className="text-[#131312]/80 leading-relaxed text-sm sm:text-base">
                  <strong>Colour Club Printers</strong> is a trading brand operated by <strong>Paper Printing Services</strong>. Both entities share the same facility, management, address, and contact details in Faisalabad, Pakistan. Paper Printing Services is the legal contracting, invoicing, and certified manufacturing entity.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
